import { useClient } from '@composables/use-clients';
import { PutRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type UpdateTenantUserRoleArgsType = {
  tenantUserId: number | null;
} & PutRequestArgsType<{ roleUid: number }>;

export const apiUpdateTenantUserRole = async ({
  payload,
  domain = useTenantStore().domain,
  tenantUserId,
  errorConfig = {},
  callbacks = {},
}: UpdateTenantUserRoleArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.tenantUserRole({ domain, tenantUserId }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
